import { memo, useCallback } from "react";

import { type Splide, type SlideComponent } from "@splidejs/splide";

import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type ProductHeroSettings } from "@root/tablescape/state";

import { UGCVideoCarouselView } from "./UGCVideoCarousel.view";

const UGCVideoCarouselBase = () => {
  const {
    ugcVideoCarousel: { heading, videos },
  } = useSectionSettings<ProductHeroSettings>();

  const playVideo = useCallback((_splide: Splide, slide: SlideComponent) => {
    slide?.slide.querySelector("video")?.play();
  }, []);

  const pauseVideo = useCallback((_splide: Splide, slide: SlideComponent) => {
    const video = slide?.slide.querySelector("video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }, []);

  if (!videos.length) {
    return null;
  }

  return (
    <UGCVideoCarouselView
      heading={heading}
      pauseVideo={pauseVideo}
      playVideo={playVideo}
      videos={videos}
    />
  );
};

export const UGCVideoCarousel = memo(UGCVideoCarouselBase);
